"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useKeyboard = void 0;
var _react = require("react");
const useKeyboard = ({
  navigation,
  hasFocusableSlides
}) => {
  const sliderRef = (0, _react.useRef)();
  const onKeydown = (0, _react.useCallback)(({
    key
  }) => {
    switch (key) {
      case 'Left':
      case 'ArrowLeft':
        return sliderRef.current?.prev();
      case 'Right':
      case 'ArrowRight':
        return sliderRef.current?.next();
      default:
        return undefined;
    }
  }, []);
  const plugin = (0, _react.useCallback)(slider => {
    sliderRef.current = slider;
    sliderRef.current.on('created', instance => {
      const {
        container
      } = instance;
      container.setAttribute('tabindex', hasFocusableSlides ? '-1' : '0');
      container.addEventListener('keydown', onKeydown);
    });
    sliderRef.current.on('destroyed', instance => {
      const {
        container
      } = instance;
      container.removeEventListener('keydown', onKeydown);
      sliderRef.current = undefined;
    });
  }, [onKeydown, hasFocusableSlides]);
  return navigation?.enableKeyboard === true ? plugin : undefined;
};
exports.useKeyboard = useKeyboard;
